import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LogNavRowProps {
  unit: 'day' | 'week';
  heading: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  /** Today is disabled when already on today / this week. */
  todayDisabled: boolean;
}

/** The original ‹ Today › row with the period as a small grey heading (both Time log views). */
export function LogNavRow({ unit, heading, onPrevious, onNext, onToday, todayDisabled }: LogNavRowProps): JSX.Element {
  const noun = unit === 'day' ? 'day' : 'week';
  return (
    <div className="mb-6 flex items-center gap-3">
      <Button variant="ghost" size="icon" aria-label={`Previous ${noun}`} onClick={onPrevious}>
        <ChevronLeft />
      </Button>
      <Button variant="ghost" size="xs" onClick={onToday} disabled={todayDisabled}>
        Today
      </Button>
      <Button variant="ghost" size="icon" aria-label={`Next ${noun}`} onClick={onNext}>
        <ChevronRight />
      </Button>
      <h2 className="text-sm font-normal text-muted-foreground">{heading}</h2>
    </div>
  );
}
